export class ProvinceModel {
    constructor(public id: string, public name: string){}
}